<template>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
                <v-card class="elevation-12">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>DKB Login</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-form>
                            <v-text-field
                                prepend-icon="mdi-login"
                                name="login"
                                label="Benutzername"
                                type="text"
                                v-model="form.username"
                                v-on:keyup.enter="login"
                                :error-messages="form.errors.get('username')"
                            ></v-text-field>
                            <v-text-field
                                id="password"
                                prepend-icon="mdi-lock"
                                name="password"
                                label="Passwort"
                                type="password"
                                v-on:keyup.enter="login"
                                v-model="form.password"
                            ></v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn type="submit" color="primary" to="/" @click="login">Login</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                    <v-card-text>
                        <div class="d-flex align-center mt-4 mb-10">
                            <v-divider></v-divider>
                            <span class="px-3">oder</span>
                            <v-divider></v-divider>
                        </div>
                        <div class="text-center mb-8">
                            <v-btn text block @click="loginWithMicrosoft" class="pa-0" style="height: auto;">
                                <img src="/images/microsoft-login.svg" alt="Microsoft Login"/>
                            </v-btn>
                            <div v-if="microsoftError" class="error--text text-caption mt-2">
                                {{ microsoftError }}
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import {useAuthService} from "@/core/api/auth";
import {useForm} from "@/core/form";
import {useMicrosoftAuthService} from "@/config/useMicrosoftAuth";
import {useIntendedRedirect} from "@/core/utils/intendedRedirect";

@Component
export default class Login extends Vue {

    private auth = useAuthService()
    private microsoftAuth = useMicrosoftAuthService()

    private form = useForm({
        username: undefined,
        password: undefined
    })

    private microsoftError: string | null = null

    mounted() {
        if (this.$route.params.microsoftError) {
            this.microsoftError = this.$route.params.microsoftError
        }
    }

    private async login() {
        this.form.usingSubmit(this.auth.login(this.form.data()))
            .then(() => {
                const redirect = useIntendedRedirect().consume()
                this.$router.push(redirect || {name: 'dashboard'})
            })
    }

    private async loginWithMicrosoft() {
        this.microsoftError = null
        try {
            await this.microsoftAuth.initialize()
            await this.microsoftAuth.login()
        } catch (error: any) {
            console.error('Authentication error:', error)
            this.microsoftError = 'Die Anmeldung mit Microsoft ist fehlgeschlagen'
        }
    }
}
</script>
